import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { capturePageview } from "@/lib/posthog";

export default function PostHogPageView() {
  const location = useLocation();

  useEffect(() => {
    capturePageview({ $current_url: window.location.href });
  }, [location.pathname, location.search]);

  return null;
}
